import { gql } from '@provision/graphql-client';

export const GET_PUSH_NOTIFICATION_CAPABILITY_QUERY = gql`
  query GetPushNotificationCapability {
    getPushNotificationCapability {
      vapidPublicKey
      subscriptions {
        id
        endpoint
        userAgent
        isActive
        lastFailedAt
        createdAt
        updatedAt
      }
    }
  }
`;

export const UPSERT_PUSH_NOTIFICATION_SUBSCRIPTION_MUTATION = gql`
  mutation UpsertPushNotification($input: PushNotificationSubscriptionInput!) {
    upsertPushNotificationSubscription(input: $input) {
      id
      endpoint
      userAgent
      isActive
      lastFailedAt
      createdAt
      updatedAt
    }
  }
`;

export const DEACTIVATE_PUSH_NOTIFICATION_SUBSCRIPTION_MUTATION = gql`
  mutation DeactivatePushNotification($endpoint: String!) {
    deactivatePushNotificationSubscription(endpoint: $endpoint) {
      success
    }
  }
`;
